export default __webpack_public_path__ + "static/media/mars32.c05931ef.gif";